"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStartPhoneVerification = exports.useSkipPhoneVerificationCode = exports.useSendPhoneVerificationCode = void 0;
var _ = require("./");
var _endpoints = require("./endpoints");
var _toast = require("./toast");
var _lodash = require("lodash");
var _phoneNumber = require("./phone-number.utils");
var useSendPhoneVerificationCode = function useSendPhoneVerificationCode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? _lodash.noop : _ref$onSuccess,
    _ref$onError = _ref.onError,
    _onError = _ref$onError === void 0 ? _lodash.noop : _ref$onError;
  var _useRequest = (0, _.useRequest)(function (_ref2) {
      var phoneNumber = _ref2.phoneNumber,
        skippable = _ref2.skippable;
      var data = {
        number: _phoneNumber.PhoneNumberUtils.getNationalNumber(phoneNumber)
      };
      var countryCode = _phoneNumber.PhoneNumberUtils.getLsPhoneNumberCountryCode();
      if (countryCode) {
        data.countryCode = countryCode;
      }
      if (!(0, _lodash.isUndefined)(skippable)) {
        data.skippable = skippable;
      }
      return {
        url: (0, _endpoints.getPatientPhoneNumberVerificationUrl)(),
        method: 'post',
        data: data,
        withErrorsHandler: false
      };
    }, {
      manual: true,
      onSuccess: onSuccess,
      onError: function onError(error) {
        var _error$response, _error$response$data;
        var message = 'Please try again or contact Support';
        var errorCode = error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.code;
        if (errorCode === 'ERR400' || errorCode === 'ERR400_102') {
          message = 'Please enter a valid mobile phone number';
        }
        _toast.toast.error({
          title: 'Verification code is not sent',
          description: message
        });
        _onError(error);
      }
    }),
    onSend = _useRequest.run,
    sending = _useRequest.loading;
  return {
    onSend: onSend,
    sending: sending
  };
};
exports.useSendPhoneVerificationCode = useSendPhoneVerificationCode;
var useStartPhoneVerification = function useStartPhoneVerification(_ref3) {
  var _onSuccess = _ref3.onSuccess,
    _onError2 = _ref3.onError;
  var _useRequest2 = (0, _.useRequest)(function (_ref4) {
      var phoneNumber = _ref4.phoneNumber,
        verificationCode = _ref4.verificationCode;
      var data = {
        number: _phoneNumber.PhoneNumberUtils.getNationalNumber(phoneNumber),
        code: verificationCode
      };
      var countryCode = _phoneNumber.PhoneNumberUtils.getLsPhoneNumberCountryCode();
      if (countryCode) {
        data.countryCode = countryCode;
      }
      return {
        url: (0, _endpoints.getPatientPhoneNumberVerificationUrl)(),
        method: 'put',
        data: data,
        withErrorsHandler: false
      };
    }, {
      manual: true,
      onSuccess: function onSuccess(verificationStatus, params) {
        if (verificationStatus !== 'approved') {
          _toast.toast.warn({
            title: 'Incorrect SMS code'
          });
          return;
        }
        _toast.toast.success({
          title: 'Your phone number is verified'
        });
        _onSuccess(verificationStatus, params);
      },
      onError: function onError(e) {
        _toast.toast.error({
          title: 'Verification failed',
          description: 'Please try again or resend the code'
        });
        _onError2(e);
      }
    }),
    onVerify = _useRequest2.run,
    verifying = _useRequest2.loading;
  return {
    onVerify: onVerify,
    verifying: verifying
  };
};
exports.useStartPhoneVerification = useStartPhoneVerification;
var useSkipPhoneVerificationCode = function useSkipPhoneVerificationCode() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref5$onSuccess = _ref5.onSuccess,
    onSuccess = _ref5$onSuccess === void 0 ? _lodash.noop : _ref5$onSuccess,
    _ref5$onError = _ref5.onError,
    onError = _ref5$onError === void 0 ? _lodash.noop : _ref5$onError,
    _ref5$onFinally = _ref5.onFinally,
    onFinally = _ref5$onFinally === void 0 ? _lodash.noop : _ref5$onFinally;
  var _useRequest3 = (0, _.useRequest)(function (_ref6) {
      var phoneNumber = _ref6.phoneNumber;
      var data = {
        number: _phoneNumber.PhoneNumberUtils.getNationalNumber(phoneNumber),
        skippable: true
      };
      var countryCode = _phoneNumber.PhoneNumberUtils.getLsPhoneNumberCountryCode();
      if (countryCode) {
        data.countryCode = countryCode;
      }
      return {
        url: (0, _endpoints.getPatientPhoneNumberVerificationSkipUrl)(),
        method: 'put',
        data: data
      };
    }, {
      manual: true,
      onSuccess: onSuccess,
      onError: onError,
      onFinally: onFinally
    }),
    onSkip = _useRequest3.run,
    skipping = _useRequest3.loading;
  return {
    onSkip: onSkip,
    skipping: skipping
  };
};
exports.useSkipPhoneVerificationCode = useSkipPhoneVerificationCode;